import { useEffect } from 'react';

import { PeriodicReviewProgressStep, useProgress } from '@/context/progress';
import PeriodicReviewSummary from '@/features/periodic-review/components/summary';
import BaseLayout from '@/layouts/base';

const PeriodicReviewSummaryPage = () => {
  const { setCurrentStep } = useProgress();

  useEffect(() => {
    return setCurrentStep(PeriodicReviewProgressStep.PERIODIC_REVIEW_CONFIRMATION);
  }, [setCurrentStep]);

  return (
    <BaseLayout>
      <PeriodicReviewSummary />
    </BaseLayout>
  );
};
PeriodicReviewSummaryPage.displayName = 'PeriodicReviewSummaryPage';

export default PeriodicReviewSummaryPage;
